'use strict';

import Vue from 'vue';
import axios from 'axios';
import router from '../router';
import { message } from 'ant-design-vue';

let config = {
  baseURL: process.env.VUE_APP_API_BASE_URL
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      config.headers.accessToken = accessToken;
    }
    const companyId = localStorage.getItem('companyId');
    if (companyId !== null || companyId !== undefined) {
      config.headers["companyId"] = companyId;
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    if (response.data.errorCode == '000628') {
      message.error('登陆超时，请重新登录!');
      router.push('/');
    }
    return response;
  },
  function(error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

_axios.$post = (url, params) =>
  _axios.post(url, params).then((res) => res.data);
_axios.$get = (url, params) =>
  _axios.get(url, { params }).then((res) => res.data);
_axios.$delete = (url, params) =>
  _axios.delete(url, { params }).then((res) => res.data);
_axios.$put = (url, params) => _axios.put(url, params).then((res) => res.data);

Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
